export default {
  calendar: (state) => {
    return state.calendar.filter(e => e.is_workday);
  }
}
